import { colors } from '@cimpress/react-components';
import { css } from '@emotion/react';
export const fileLabelSimpleCss = css `
    font-weight: 600;
    padding: 0px 3px 0px 3px;
    border: 0px;
    margin-right: 5px;
    margin-bottom: 5px;
    display: inline-block;
`;
export const transmissionSelectionCss = css `
   border: 2px;
   border-right: 2px dotted ${colors.shale};
   border
`;
export const overviewValueCss = css `
    word-break: break-word;
    font-size: 14px;
    display: block;
    font-weight: 600;
`;
export const apiPushtransmissionSelectionCss = css `
   width: 18em;
   padding: 20px;
   border: 2px;
   border-right: 2px dotted ${colors.shale};
`;
export const fileDetailCss = css `
padding: 10px 10px 10px 0px;
marginBottom: 10px;
whiteSpace: nowrap
`;
export const buttonTextCss = css `
    font-weight: 700;
    padding: 0px 3px 0px 4px;
    border: 0px;
    margin-right: 3px;
    margin-bottom: 1%;
    display: inline-block;
`;
export const detailLabelCss = css `
    color: ${colors.slate};
    margin-bottom: 10px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    display: block;
    alignItems: center;
`;
export const detailErrorLabelCss = css `
    color: ${colors.persimmon.darker};
    margin-bottom: 1%;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    display: block;
    alignItems: center;
`;
export const detailTableLabelCss = css `
    color: ${colors.slate};
    margin-bottom: 40px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    display: block;
    alignItems: center;
`;
export const errorCss = css `
    font-weight: 700;
    color: ${colors.danger.base};
`;
export const cssErrorRow = css `
    gap: 10px;
    padding: 10px 10px 10px 7px;
    display: flex;
    align-items: flex-start;
`;
